import Vue from 'vue'
import Router from 'vue-router'
import storeManagementRouter from './modules/storeManagement'
import automaticShelvingRouter from './modules/automaticShelving'
import materialManagementRouter from './modules/materialManagement'
import goodsManagementRouter from './modules/goodsManagement'
import systemRouter from './modules/systemRouter'
import reportRouter from './modules/reportList'
import mainBodyRouter from './modules/mainBodyRouter'
import supplierRouter from './modules/supplier'
Vue.use(Router)

/* Layout */
import Layout from '@/layout'

/**
 * Note: sub-menu only appear when route children.length >= 1
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'/'el-icon-x' the icon show in the sidebar
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  {
    path: '/404',
    component: () => import('@/views/404'),
    hidden: true
  },
  {
    path: '/common',
    component: Layout,
    children: [{
      path: '/common/importList',
      name: 'ImportList',
      component: () => import('@/views/common/importList'),
      meta: { title: '导入列表', icon: 'importList' }
    }],
    hidden: true
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [{
      path: 'dashboard',
      name: 'Dashboard',
      component: () => import('@/views/dashboard/index'),
      meta: { title: '首页', icon: 'dashboard' }
    }]
  },
  // systemRouter,
]

/**
 * the routes that need to be dynamically loaded based on user roles
 */
export const asyncRoutes = [
  // 店铺管理路由表
  storeManagementRouter,
  // 自动上架路由表
  automaticShelvingRouter,
  // 素材管理路由表
  materialManagementRouter,
  // 商品管理路由表
  goodsManagementRouter,
  // 报表管理路由表
  reportRouter,
  // 系统设置路由
  systemRouter,
  // 主体管理
  mainBodyRouter,
  // 供应商管理
  supplierRouter,
  // 404 page must be placed at the end !!!
  { path: '*', redirect: '/404', hidden: true }
]

const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
